import React from 'react';
import { useTheme } from '@mui/material/styles';
import MuiChip, { ChipProps } from '@mui/material/Chip';
import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

interface chipProps extends ChipProps {
  chipColor?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  label?: string;
  avatar?: React.ReactElement | undefined;
  onDelete?: () => void;
  onClick?: () => void;
  darkModeOn?: boolean;
}

// ==============================|| CHIP ||============================== //

const Chip = ({
  chipColor,
  disabled,
  sx = {},
  darkModeOn,
  ...others
}: chipProps) => {
  const theme = useTheme();

  let defaultSX: SxProps<Theme> = {
    border: `1px solid ${theme.palette.primary.main}`,
    color:
      darkModeOn || theme.palette.mode === 'dark'
        ? theme.palette.primary.light
        : theme.palette.primary.main,
    backgroundColor:
      darkModeOn || theme.palette.mode === 'dark'
        ? theme.palette.primary.main
        : theme.palette.primary.light
  };

  switch (chipColor) {
    case 'secondary':
      defaultSX = {
        border: `1px solid ${theme.palette.secondary.main}`,
        color:
          darkModeOn || theme.palette.mode === 'dark'
            ? theme.palette.secondary.light
            : theme.palette.secondary.main,
        bgcolor:
          darkModeOn || theme.palette.mode === 'dark'
            ? theme.palette.secondary.dark
            : theme.palette.secondary.light
      };
      break;
    case 'success':
      defaultSX = {
        border: `1px solid ${theme.palette.success.dark}`,
        color:
          darkModeOn || theme.palette.mode === 'dark'
            ? theme.palette.success.light
            : theme.palette.success.dark,
        bgcolor:
          darkModeOn || theme.palette.mode === 'dark'
            ? theme.palette.success.dark
            : theme.palette.success.light + 60
      };
      break;
    case 'error':
      defaultSX = {
        border: `1px solid ${theme.palette.error.main}`,
        color:
          darkModeOn || theme.palette.mode === 'dark'
            ? theme.palette.error.light
            : theme.palette.error.dark,
        backgroundColor:
          darkModeOn || theme.palette.mode === 'dark'
            ? theme.palette.error.dark
            : theme.palette.error.light + 60
      };
      break;
    case 'orange':
      defaultSX = {
        border: `1px solid ${theme.palette.orange.main}`,
        color: theme.palette.orange.dark,
        backgroundColor: theme.palette.orange.light
      };
      break;
    case 'warning':
      defaultSX = {
        border: `1px solid ${theme.palette.warning.dark}`,
        color: theme.palette.warning.dark,
        backgroundColor: theme.palette.warning.light
      };
      break;
    case 'grey':
      defaultSX = {
        border: `0px`,
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.grey[300]
      };
      break;
    default:
  }

  if (disabled) {
    defaultSX = {
      border: `1px solid ${theme.palette.grey[500]}`,
      color: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[50]
    };
  }

  let SX: SxProps<Theme> = defaultSX;
  SX = { ...SX, ...sx };
  return <MuiChip {...others} sx={SX} />;
};

export default Chip;
